export { default as rootReducer } from './rootReducer';
